import React from 'react';

export default function Logo() {
  return (
    <svg width="42" height="38" viewBox="0 0 42 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 6.17804H5.10448V11.2825H0V6.17804Z" fill="#FD9C4A"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.86236 2.44436L7.8626 2.39992H7.86236V0H10.2347V0.0373993C10.4636 0.0124377 10.7095 0 10.9726 0H24.1912C35.1327 0 41.0755 4.26652 41.0755 14.3995C41.0755 25.1991 35.1882 29.999 24.1912 29.999L17.6996 29.999V24.7716C17.6996 24.249 17.9524 24.0312 18.4159 24.0312H27.2649C33.9227 24.0312 36.4088 19.2402 36.4088 14.7977C36.4088 10.0939 33.6698 5.99981 27.2649 5.99981H12.6851V11.1392H27.4756C30.1724 11.1392 31.3944 12.9249 31.3944 15.059C31.3944 17.1061 30.2567 19.1096 27.4334 19.1096H17.1939C14.0757 19.1096 12.7273 20.4597 12.7273 23.7699V29.999L10.9726 29.999L10.9434 29.9989H7.8623V26.5959H7.86236V2.44436Z" fill="url(#paint0_linear_47_824)"/>
      <path d="M12.4775 32.8955H17.582V38H12.4775V32.8955Z" fill="#FF6E9B"/>
      <defs>
        <linearGradient id="paint0_linear_47_824" x1="3.93127" y1="6.22414" x2="36.0347" y2="35.0518" gradientUnits="userSpaceOnUse">
          <stop offset="0.0572737" stopColor="#FDAB2F"/>
          <stop offset="0.510417" stopColor="#FF629A" stopOpacity="0.94"/>
          <stop offset="1" stopColor="#7C0DEB"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
